import { styled } from "styled-components";

export const HeaderWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: 20px calc(20px + 4px) 0 0;

  display: flex;
  gap: 12px;
  z-index: 3;
`;

export const UsernameWrapper = styled.div`
  padding: 24px;
`;

export const BackIcon = styled.img`
  cursor: pointer;
  position: absolute;
  top: 187px;
  left: 258px;
`;

export const HeaderText = styled.div`
  /* height: 52px; */
  display: flex;
  align-items: center;
`;
